import axios from 'axios';
import { toast } from 'components/elements/molecules/Toast/Toast';

export const LOGGED_MEDIA_ANALYTICS = 'LOGGED_MEDIA_ANALYTICS';

export function mediaLoggedAnalysis(username) {
  return (dispatch) => {
    return axios({
      method: 'get',
      url: '/api/dashboard/mediaLoggedAnalysis',
      params: { username },
    })
      .then((response) => {
        const data = response.data;

        dispatch({
          type: LOGGED_MEDIA_ANALYTICS,
          payload: data,
        });

        return data;
      })
      .catch((e) => {
        console.error('Error while fetching logged media analytics', e);
      });
  };
}

export function activitiesOverTime(usernames) {
  return (dispatch) => {
    return axios({
      method: 'get',
      url: '/api/dashboard/activitiesOverTime',
      params: { usernames },
    })
      .then((response) => {
        const data = response.data;

        return data;
      })
      .catch((e) => {
        console.error('Error while fetching activities over time', e);
        toast('Error occurred while fetching activities over time', {
          type: 'error',
        });
      });
  };
}

export function vocabularyActivitiesOverTime(usernames) {
  return (dispatch) => {
    return axios({
      method: 'get',
      url: '/api/dashboard/vocabularyActivitiesOverTime',
      params: { usernames },
    })
      .then((response) => {
        const data = response.data;

        return data;
      })
      .catch((e) => {
        console.error(
          'Error while fetching vocabulary activities over time',
          e,
        );
        toast('Error occurred while fetching vocabulary activities over time', {
          type: 'error',
        });
      });
  };
}
